import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { deleteUser, editUser } from '../userManagementActions';
import PropTypes from 'prop-types';
import {
    getDeleteUserErrorMessage,
    getIsDeleteUserLoading,
    getIsDeleteUserSuccessful,
    getEditUserErrorMessage,
    getIsEditUserLoading,
    getIsEditUserSuccessful
} from '../userManagementEntity';
import { toastIfError } from '../../../utils/toast';
import { toggleModal } from '../../Modal/modalActions';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import { getDataByUniqueModalName } from '../../Modal/modalViewState';
import UserForm from '../UserForm/UserForm';

export class EditUser extends Component {
    static propTypes = {
        onEditUser: PropTypes.func.isRequired,
        editUserError: PropTypes.string,
        isEditUserLoading: PropTypes.bool,
        isEditUserSuccessful: PropTypes.bool,
        onDeleteUser: PropTypes.func.isRequired,
        deleteUserError: PropTypes.string,
        isDeleteUserLoading: PropTypes.bool,
        isDeleteUserSuccessful: PropTypes.bool,
        onToggleModal: PropTypes.func.isRequired,
        user: PropTypes.any
    };

    constructor(props) {
        super(props);

        this.state = {
            username: '',
            merchantIds: [],
            payoutAccountIds: [],
            role: undefined,
            userId: ''
        };
    }

    componentDidUpdate(previousProps) {
        toastIfError(previousProps, this.props, 'editUserError');
        toastIfError(previousProps, this.props, 'deleteUserError');

        if (doesPropExistAndHasItChanged(previousProps, this.props, 'isEditUserSuccessful') && this.props.isEditUserSuccessful) {
            this.props.onToggleModal();
            toast('User Edited Successfully.', { type: 'success' });
        }

        if (doesPropExistAndHasItChanged(previousProps, this.props, 'isDeleteUserSuccessful') && this.props.isDeleteUserSuccessful) {
            this.props.onToggleModal();
            toast('User Deleted Successfully.', { type: 'success' });
        }

        if (doesPropExistAndHasItChanged(previousProps, this.props, 'user')) {
            const { user } = this.props;

            let role = user.role || user.accessRights.role;

            if (user.isApiUser) {
                role = 'API';
            }

            this.setState({
                username: user.userName,
                merchantIds: Object.keys(user.accessRights.merchantIds),
                payoutAccountIds: Object.keys(user.payoutAccessRights),
                role,
                userId: user.cognitoSub,
                apiKey: user.apiKey
            });
        }
    }

    handlePayoutAccountsChange = (selectedOptions = []) => {
        const payoutAccountIds = selectedOptions.map((option) => option.value);

        this.setState({ payoutAccountIds });
    };

    handleMerchantsChange = (selectedOptions = []) => {
        const merchantIds = selectedOptions.map((option) => option.value);

        this.setState({ merchantIds });
    };

    handleSelectAccessRole = (role) => {
        this.setState({ role });
    };

    handleDeleteUser = () => {
        this.props.onDeleteUser({ username: this.state.username });
    };

    handleEditUser = () => {
        let role = this.state.role;
        let isApiUser = false;
        if (this.state.role === 'API') {
            role = 'W';
            isApiUser = true;
        }

        this.props.onEditUser(this.state.userId, this.state.merchantIds, this.state.payoutAccountIds, role, isApiUser);
    };

    render() {
        return (<UserForm
            modalTitle="Nexio User"
            username={this.state.username}
            isSubmitLoading={this.props.isEditUserLoading}
            isDeleteLoading={this.props.isDeleteUserLoading}
            isEdit={true}
            isApiUser={this.state.role === 'API'}
            merchantIds={this.state.merchantIds}
            onDelete={this.handleDeleteUser}
            onMerchantsChange={this.handleMerchantsChange}
            payoutAccountIds={this.state.payoutAccountIds}
            onPayoutAccountsChange={this.handlePayoutAccountsChange}
            onSelectAccessRole={this.handleSelectAccessRole}
            onSubmit={this.handleEditUser}
            role={this.state.role}
            apiKey={this.state.apiKey}
            submitText="Save"
            uniqueModalName="editUser"
        />);
    }
}

function mapStateToProps(state, ownProps) {
    return {
        editUserError: getEditUserErrorMessage(state),
        isEditUserLoading: getIsEditUserLoading(state),
        isEditUserSuccessful: getIsEditUserSuccessful(state),
        deleteUserError: getDeleteUserErrorMessage(state),
        isDeleteUserLoading: getIsDeleteUserLoading(state),
        isDeleteUserSuccessful: getIsDeleteUserSuccessful(state),
        user: getDataByUniqueModalName(state, 'editUser')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onEditUser: (userId, merchantIds, payoutAccountIds, role, isApiUser) => {
            dispatch(editUser(userId, merchantIds, payoutAccountIds, role, isApiUser));
        },
        onDeleteUser: (user) => dispatch(deleteUser(user)),
        onToggleModal: () => dispatch(toggleModal('editUser', undefined))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditUser);
